const languageOptions: { value: General.SystemLanguage; label: string }[] = [
  {
    value: 'zh-CN',
    label: '中文简体',
  },
  {
    value: 'en-US',
    label: 'English',
  },
  {
    value: 'id',
    label: 'Indonesia',
  },
  {
    value: 'th',
    label: 'ภาษาไทย',
  },
  {
    value: 'tl',
    label: 'Filipino',
  },
  {
    value: 'vi',
    label: 'Tiếng Việt',
  },
  {
    value: 'pt',
    label: 'Português',
  },
  {
    value: 'es',
    label: 'Español',
  },
];

export default languageOptions;
